<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex mb-4>
        <h2>Please Sign In</h2>
        <v-form v-model="valid">
          <v-container>
            <v-row justify="center">
              <v-col cols="5">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  autocomplete="email"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="5">
                <v-btn @click="passwordResetActivate()" color="primary" large block>Password Reset</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <router-link to="sign-in" class="text-decoration-none font-weight-medium">Sign In</router-link> |
                <router-link to="join-team" class="text-decoration-none font-weight-medium">Join Team</router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" :color="snackbarColor">
      <span v-html="snackbarMessage" @click="snackbar = false"></span>
    </v-snackbar>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    show: false,
    snackbar: false,
    snackbarMessage: '',
    snackbarTimeout: 3000,
    snackbarColor: 'success',
  }),

  methods: {
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    passwordResetActivate () {
      console.log('Password Reset: activate')
      firebase.auth().sendPasswordResetEmail(this.email).then(() => {
        // alert('Password Reset Email Sent')
        this.snackbarMessage = 'Password reset email sent successfully.'
        this.snackbarTimeout = 3000
        this.snackbarColor = 'success'
        this.snackbar = true
        setTimeout(() => {
          this.$router.push({ path: '/sign-in' })
        }, 3500)
      }).catch((error) => {
        // alert(error.message + ' - Contact a team admin via Slack or Email if you have any questions.')
        this.snackbarMessage = error.message + ' - Contact a team admin via Slack or Email if you have any questions.'
        this.snackbarTimeout = 0
        this.snackbarColor = 'error'
        this.snackbar = true
      })
    },
  },
}
</script>
